import ApplicationLauncher from '@/components/_core/ui/application-launcher';
import ApplicationStatus from '@/components/_core/ui/application-status';
import Context from '@/components/_core/ui/header/user-app-actions/components/context';
import Role from '@/components/_core/ui/header/user-app-actions/components/role';
import Notifications from '@/components/_core/ui/notifications';
import TermAndPrivacy from '@/components/_core/ui/terms-and-privacy';
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { SAFEA_VERSION, SAFEA_VERSIONS } from '~/constants/_core/safea-v3';

export default Vue.extend({
  components: {
    Role,
    Context,
    Notifications,
    ApplicationLauncher,
    ApplicationStatus,
    TermAndPrivacy
  },
  data() {
    return {
      showUserMenu: false
    };
  },
  computed: {
    ...mapGetters({
      isImpersonated           : '_core/auth/isImpersonated',
      applicationStatusEnabled : '_core/applicationStatus/applicationStatusEnabled',
      notificationEnabled      : '_core/notification/notificationEnabled',
      actionList               : '_core/application/actionList'
    }),
    ...mapState({
      currentRights : (state) => state._core.auth.currentRole,
      user          : (state) => state._core.user,
      userPhoto     : (state) => state._core.user.photo,
      userName      : (state) => state._core.user.name
    }),
    applicationLauncherEnabled() {
      return !this.isImpersonated && process.env.BROWSE_BETWEEN_APPS_ENABLED === 'true';
    },
    isSafeAV3() {
      return SAFEA_VERSION === SAFEA_VERSIONS.V3;
    }
  },
  methods: {
    getInitials(string) {
      if (string) {
        const names = string.split(' '); let initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
          initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      }

      return '';
    }
  }
});
